import { render, staticRenderFns } from "./InfoDetailsSpecialRiskQuestion.vue?vue&type=template&id=2f6c1766&scoped=true"
import script from "./InfoDetailsSpecialRiskQuestion.vue?vue&type=script&lang=js"
export * from "./InfoDetailsSpecialRiskQuestion.vue?vue&type=script&lang=js"
import style0 from "./InfoDetailsSpecialRiskQuestion.vue?vue&type=style&index=0&id=2f6c1766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c1766",
  null
  
)

/* custom blocks */
import block0 from "./InfoDetailsSpecialRiskQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports